import script from "./BrandBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandBar.vue?vue&type=script&setup=true&lang=js"

import "./BrandBar.vue?vue&type=style&index=0&id=1a02d955&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a02d955"]])

export default __exports__